const state = {
    layer_video_open: false,
    video_cover_url: '',
    video_address:'',
		img_cover_indx: '',
}

const mutations = {
    SET_LAYER_VIDEO_OPTIONS: (state, options) => {
        state.layer_video_open = true
        state.video_cover_url = options.cover
        state.video_address = options.video
				state.img_cover_indx = options.index
    },
    SET_LAYER_VIDEO_CLOSE: (state) => {
        state.layer_video_open = false
				state.video_cover_url = ''
				state.video_address = ''
				state.img_cover_indx = ''
				
    },
}

const actions = {
    open({ commit }, {cover, video, index}) {
        commit('SET_LAYER_VIDEO_OPTIONS',{cover,video,index})
    },
    close({ commit }) {
        commit('SET_LAYER_VIDEO_CLOSE')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
